import { Outlet } from 'react-router';

/** Top of the tree: global concerns that are not tied to a data source. */
export function RootLayout() {
  return <Outlet />;
}
